const colors = {
  // refactored with scss
  black: "#000000",
  blue: "#04a4e6",
  darkGreen: "#487f28",
  darkGrey: "#636466",
  orange: "#E99200",
  yellow: "#E2C400",
  green: "#6AB23D",
  instructorGreen: "#629E3D",
  lemon: "#C3CE18", // required for bar chart
  violet: "#AB48AF",
  white: "#FFFFFF",
  studentBlue: "#405A9C",
  selectionBlue: "#F5F6FD",
  selectedItemBlue: "#bed6ff",
  lightestGrey: "#ededed",
  midGrey: "#b8b8b8",
  lightGreen: "#62b144",
  grey: "#999999",
  lightGrey: "#dadada",
  lightestGreen: "#9FD18FCC",
  lightRed: "#f6483a",
  darkRed: "#b2281b",
  red: "#e83b2d",
  lightBlue: "#5ABDFF",
  lightestBlue: "#F4F6FC"
};
export const setContrast = (backgroundColor: string) => {
  const rgbBase = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(backgroundColor);
  const rgb = [parseInt(rgbBase[1], 16), parseInt(rgbBase[2], 16), parseInt(rgbBase[3], 16)];
  const brightness = Math.round((rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000);
  return brightness > 170 ? "dark" : "light";
};

export const calendarItemColorMap = {
  sessions: colors.instructorGreen,
  worksheets: colors.studentBlue,
  lessons: colors.orange,
  tests: colors.violet,
  "writing and languages": colors.orange,
  "reading & writings": colors.orange,
  maths: colors.orange,
  readings: colors.orange,
  englishs: colors.orange,
  sciences: colors.orange
};

export const ICONS_COLORS = {
  completed: colors.lightGreen,
  started: colors.orange,
  assigned: colors.black,
  created: colors.grey,
  unassigned: colors.midGrey
};

export const subjectsColors = [
  colors.instructorGreen,
  colors.lightBlue,
  colors.orange,
  colors.yellow
];

export default colors;
